<mat-card>
  <mat-card-header>
    <mat-card-title>Tarefas</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    @if (isLoading) {
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    }
    @if (!isLoading) {
      <div>
        @if (tasks.length === 0) {
          <div class="no-tasks">
            <p>Nenhuma tarefa</p>
          </div>
        }
        @if (tasks.length > 0) {
          <div>
            @for (task of tasks; track task) {
              <app-task-summary-tile
                [task]="task"
                (taskClick)="navigateToTask($event)">
              </app-task-summary-tile>
            }
          </div>
        }
      </div>
    }
  </mat-card-content>
  <mat-card-actions align="end" class="button-spacing">
    @if (tasks.length > 0) {
      <button mat-raised-button color="primary" (click)="navigateToAllTasks()">Ver todas</button>
    }
    <button mat-raised-button color="accent" (click)="navigateToCreateTask()">Criar</button>
  </mat-card-actions>
</mat-card>
